module.exports = __webpack_public_path__ + "img/categorie-huitres-famille-boutrais-small.fe28171a.jpg";